import apiClient from './apiClient';

export type PageType = 'help' | 'support' | 'contact' | 'about' | 'terms' | 'privacy' | 'custom';

export interface Page {
  _id: string;
  title: string;
  slug: string;
  type: PageType;
  content: string;
  metaTitle?: string;
  metaDescription?: string;
  isActive: boolean;
  order: number;
  createdBy?: {
    _id: string;
    name?: string;
    username?: string;
  };
  updatedBy?: {
    _id: string;
    name?: string;
    username?: string;
  };
  createdAt: string;
  updatedAt: string;
}

class PageService {
  async getPages(type?: string, isActive?: boolean | 'all') {
    const params: any = {};
    if (type) params.type = type;
    if (isActive !== undefined) params.isActive = isActive.toString();
    
    const response = await apiClient.get('/pages', { params });
    return response.data;
  }

  async getPageBySlug(slug: string) {
    const response = await apiClient.get(`/pages/slug/${slug}`);
    return response.data;
  }

  async getPageById(id: string) {
    const response = await apiClient.get(`/pages/${id}`);
    return response.data;
  }

  async createPage(data: Partial<Page>) {
    const response = await apiClient.post('/pages', data);
    return response.data;
  }

  async updatePage(id: string, data: Partial<Page>) {
    const response = await apiClient.put(`/pages/${id}`, data);
    return response.data;
  }

  async deletePage(id: string) {
    const response = await apiClient.delete(`/pages/${id}`);
    return response.data;
  }

  async togglePageStatus(id: string) {
    const response = await apiClient.patch(`/pages/${id}/toggle-status`);
    return response.data;
  }
}

export const pageService = new PageService();
export default pageService;

